var React = require('react');

function AccountStatus (props) {
    return React.createElement("svg",props,React.createElement("rect",{"width":"12","height":"12","rx":"6","fill":"#43936F"}));
}

AccountStatus.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = AccountStatus;

AccountStatus.default = AccountStatus;
